export const getUnitIconClassNameForCombatResults = (unitTypeId) => {
  const specialStyles = {
    unit_d4: 'combat-results_unit-img-d4-d6',
    unit_d6: 'combat-results_unit-img-d4-d6'
  }
  return specialStyles[unitTypeId] || `combat-results_unit`;
}